export class ClipBoardHelper {
  static copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text).then(() => {
    });
  }
}
